module.exports = __webpack_public_path__ + "img/32.36468613.png";